import { renewalProposalService } from './../../../Services/renewalProposalService';
import { RenewBindMdl } from './../../../Models/RenewBindMdl';
import { TPLProposal } from './../../../Models/TPLProposal';
import { Router } from '@angular/router';
import { MotorProposal } from './../../../Models/MotorProposal';
import { Component, OnDestroy, DoCheck } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { restURL } from '../../../Models/restURL';
import { Subscription } from 'rxjs';
import { motorProposalService } from '../../../Services/motorProposalService';
import { BindMdl } from '../../../Models/BindMdl';
import { LanguageService } from '../../../Services/languageService';
import { KeyValueChanges, KeyValueDiffer, KeyValueDiffers } from '@angular/core';
import { MotorproposalTrackingService } from '../../../Services/MotorproposalTrackingService';
@Component({
    selector: 'RenewalVehicleDetails',
    templateUrl: './RenewalVehicleDetails.html',
    styleUrls: ['./RenewalVehicleDetails.css']
  })
  export class RenewalVehicleDetails{
    public prObj:TPLProposal=new TPLProposal();
    public bindObj:RenewBindMdl=new RenewBindMdl();
    public  httpOptions = {headers: new HttpHeaders({'Content-Type':  'application/json'})}; 
    public isShowLoading:boolean;
    public LngSubscription:Subscription; 
    public  subscription: Subscription;
    public bindSubscription:Subscription;
    public Lng:string;
    public isError:boolean;
    public ErrorMsg:string;
    public isOfficeAddr:boolean;
    public isSubmitted:boolean;
    public EducationValidation: boolean = false;

    public constructor(private router: Router,private http:HttpClient,private url:restURL,private proposalService:renewalProposalService,private lngService:LanguageService)
    {
      this.isOfficeAddr=false;
      this.isSubmitted=false;
      this.LngSubscription=this.lngService.grtLng().subscribe(lng=>{
        this.Lng=lng
      });
      
      if(sessionStorage.getItem("rp")===null)
      {      
      this.subscription = this.proposalService.getRenewProposal().subscribe(message => { this.prObj = message; });
      this.bindSubscription = this.proposalService.getRenewBindInfo().subscribe(message => { this.bindObj = message; });
            }
      else
      {
       this.prObj=this.proposalService.getRenewalProposalObj();
      this.bindObj=this.proposalService.getRenewalBindObj();
     
      }
      
      if(sessionStorage.getItem("Language")!=null)
      {
        this.Lng=sessionStorage.getItem("Language");
      }
      else
      {
       this.Lng="en";
      }
    }

    goPrev()
    {
      this.proposalService.saveRenewalProposalObj(this.prObj);
      this.proposalService.saveRenewalBindObj(this.bindObj);
      sessionStorage.setItem("CurrentRoute","RenewalPremiumInfo");
      if( this.prObj.st.StatusCode=="S")
      {
      this.router.navigate(['NewDashboard/RenewalProposal/RenewalPremiumInfo']);
      }

    }
    CheckValidEducation(val){
      if(val == null || val == undefined){
        this.EducationValidation = true;
      }else{
        this.EducationValidation = false;
      }
    }
    goNext(valid)
    { 
      if(!valid){
        this.isSubmitted=true;
        return;
      }
     
        
      this.proposalService.saveRenewalProposalObj(this.prObj);
      this.proposalService.saveRenewalBindObj(this.bindObj);   
      if(this.prObj.st.StatusCode=="S")
     {
      sessionStorage.setItem("CurrentRoute","RenewalReviewConfirm");
      this.router.navigate(['NewDashboard/RenewalProposal/RenewalReviewConfirm']);
     }

     
    }
  }




// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/RenewalVehicleDetails/RenewalVehicleDetails.ts